// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wordWrap[data-v-3935f8fa]{word-wrap:break-word}", ""]);
// Exports
module.exports = exports;
